var _rect, _rect2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "#F3F3F3",
    rx: 24.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "#F3F3F3",
    rx: 24.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "map_svg__a",
    width: 32,
    height: 32,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M9 9h32v32H9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#map_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60656B",
    d: "M25 31.44q3.541-2.83 5.352-5.438 1.81-2.608 1.81-4.964 0-2.01-.733-3.414-.734-1.404-1.812-2.28a7 7 0 0 0-2.33-1.273q-1.25-.396-2.286-.396t-2.289.396a7 7 0 0 0-2.33 1.272q-1.079.877-1.811 2.281-.735 1.404-.734 3.414 0 2.355 1.81 4.964 1.81 2.608 5.353 5.437m0 1.712a1.54 1.54 0 0 1-.97-.347q-2.622-2.053-5.245-5.095t-2.623-6.672q0-2.235.8-3.92.8-1.683 2.068-2.827a8.6 8.6 0 0 1 2.849-1.717q1.58-.574 3.12-.574t3.121.574a8.6 8.6 0 0 1 2.849 1.717q1.268 1.144 2.068 2.828t.8 3.919q0 3.63-2.622 6.672-2.623 3.042-5.246 5.095a1.54 1.54 0 0 1-.97.347m.002-10.143q.906 0 1.537-.634a2.1 2.1 0 0 0 .632-1.54q0-.906-.634-1.537a2.1 2.1 0 0 0-1.54-.631q-.906 0-1.537.633-.63.634-.631 1.54 0 .906.634 1.537a2.1 2.1 0 0 0 1.54.632M17 37.999a.8.8 0 0 1-.597-.241.82.82 0 0 1-.24-.6q0-.358.24-.596a.82.82 0 0 1 .597-.237h16q.356 0 .596.242.241.241.241.6 0 .358-.24.595A.82.82 0 0 1 33 38z"
  }))));
};
export default SvgMap;